export const DEFAULT_FONT_FAMILY = 'Inter, sans-serif';

export const DEFAULT_LOADER_SIZE = 20;

export enum Size {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum TokenSize {
  ExtraSmall = 'extraSmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum TabType {
  Internal = 'internal',
  External = 'external',
  Embedded = 'embedded',
  Text = 'text',
}

export enum TableVariant {
  Contained = 'contained',
  Secondary = 'secondary',
}

export enum Align {
  Start = 'start',
  End = 'end',
  Center = 'center',
}

export enum Variant {
  Contained = 'contained',
  Outlined = 'outlined',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Secondary = 'secondary',
  SecondaryDark = 'secondaryDark',
  Square = 'square',
  CircleGray = 'circleGray',
  CircleDark = 'circleDark',
  Gradient = 'gradient',
  Clear = 'clear',
  Range = 'range',
  TextGray = 'textGray',
  TextBlue = 'textBlue',
  TextWhite = 'textWhite',
}

export enum SliderVariant {
  Primary = 'primary',
  Warning = 'warning',
}

export enum LinkVariant {
  Primary = 'primary',
  Light = 'light',
}

export enum LinkBtnType {
  Route = 'route',
  Link = 'link',
  Button = 'button',
}

export enum Breakpoint {
  Xl = 'xl',
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs',
}

export enum BreakpointSize {
  Xl = 1440,
  Lg = 1280,
  Md = 860,
  Sm = 600,
  Xs = 375,
}

export enum Index {
  Footer = 100,
  Header = 100,
}

export const HEADER_HEIGHT_DESKTOP = 88;

export const FOOTER_HEIGHT_DESKTOP = 356;

export const DESKTOP_TOTAL_HEIGHT =
  HEADER_HEIGHT_DESKTOP + FOOTER_HEIGHT_DESKTOP;

export const HEADER_HEIGHT_MOBILE = HEADER_HEIGHT_DESKTOP;

export const FOOTER_HEIGHT_MOBILE = 694;

export const MOBILE_TOTAL_HEIGHT = HEADER_HEIGHT_MOBILE + FOOTER_HEIGHT_MOBILE;
